import { buildUrlUsingBase } from "../../../../../../constants";

export type MenuLinkItemType = {
    label: string;
    to?: string;
    type: "link" | "navigate",
    target?: string;
};

export const buyPageLinks: MenuLinkItemType[] = [
    { 
        label: "Down Payment Program",
         to: buildUrlUsingBase('buyer#upfront-down-payment-assistance'),
        type: 'link'
    },
    { 
        label: "Why Zown",
         to: buildUrlUsingBase('buyer#why-zown'),
        type: 'link'
    },
    { 
        label: "How It Works",
         to: buildUrlUsingBase('buyer/how-it-works'),
        type: 'link'
    },
    { 
        label: "What's the Catch?",
         to: buildUrlUsingBase('buyer#whats-the-catch'),
        type: 'link'
    },
    { 
        label: "FAQs",
         to: buildUrlUsingBase('buyer#faqs'),
        type: 'link'
    },
    {
        label: "Tools",
        type: 'navigate',
        target:'buy/tools'
     
    },
    {
        label: "Resources",
        type: 'navigate',
        target:'buy/resources'
    
    }
];

export const sellPageLinks: MenuLinkItemType[] = [
    {
        label: "Why Sell with Zown",
        to: buildUrlUsingBase('seller#why-sell-with-zown'),
        type: 'link'
    },
    {
        label: "How It Works",
        to: buildUrlUsingBase('seller#how-it-works'),
        type: 'link'
    },
    {
        label: "FAQs",
        to: buildUrlUsingBase('seller#faqs'),
        type: 'link'
    },
    {
        label: "Tools",
        type: 'navigate',
        target:'sell/tools'
    },
    {
        label: "Resources",
        type: 'navigate',
        target:'sell/resources'
    }
];

export const sellBuyPageLinks: MenuLinkItemType[] = [
    {
        label: "Upsizing with Zown",
        to: buildUrlUsingBase('upsize#upsizing-with-zown'),
        type: 'link'
    },
    {
        label: "How It Works",
        to: buildUrlUsingBase('upsize#how-it-works'),
        type: 'link'
    },
    {
        label: "Why Zown",
        to: buildUrlUsingBase('upsize#why-upsize-with-zown'),
        type: 'link'
    },
    {
        label: "FAQs",
        to: buildUrlUsingBase('upsize#faq'),
        type: 'link'
    },
    {
        label: "Tools",
        type: 'navigate',
        target: 'sell-buy/tools',
    },
    {
        label: "Resources",
        type: 'navigate',
        target: 'sell-buy/resources',
    }
];

export const buyToolsPageLinks: MenuLinkItemType[] = [
    { 
        label: "Browse Homes",
         to: buildUrlUsingBase(''),
        type: 'link'
    },
    { 
        label: "Affordability Calculator",
         to: buildUrlUsingBase('calculator/home-affordability'),
        type: 'link'
    },
    { 
        label: "Mortgage Calculator",
         to: buildUrlUsingBase('calculator/mortgage-payment'),
        type: 'link'
    },
    { 
        label: "Affordability Map",
         to: buildUrlUsingBase('buyer/affordability-map'),
        type: 'link'
    },
    {
        label: "Mortgage Pre-Qualification",
        to: buildUrlUsingBase('buyer/mortgage-pre-qualification'),
        type: 'link'
    }
]

export const sellToolsPageLinks: MenuLinkItemType[] = [
    {
        label: "Instant Home Valuation",
        to: buildUrlUsingBase('seller/instant-home-valuation'),
        type: 'link'
    },
    {
        label: "Sell Cost Calculator",
        to: buildUrlUsingBase('calculator/home-selling-cost'),
        type: 'link'
    },
    {
        label: "Commission Calculator",
        to: buildUrlUsingBase('calculator/commissions'),
        type: 'link'
    }
]

export const sellBuyToolsPageLinks: MenuLinkItemType[] = [
    {
        label: "Instant Home Valuation",
        to: buildUrlUsingBase('seller/instant-home-valuation'),
        type: 'link'
    },
    {
        label: "Browse Homes",
        to: buildUrlUsingBase('https://homes.zown.ca/'),
        type: 'link'
    },
    {
        label: "Sell Cost Calculator",
        to: buildUrlUsingBase('calculator/home-selling-cost'),
        type: 'link'
    },
    {
        label: "Affordability Map",
        to: buildUrlUsingBase('buyer/affordability-map'),
        type: 'link'
    }
]

export const buyResourcesPageLinks: MenuLinkItemType[] = [
    { 
        label: "FTHB Guide",
        to: buildUrlUsingBase('buyer/home-buying-guide'),
        type: 'link'
    },
    { 
        label: "Mortgage Rates",
        to: buildUrlUsingBase('buyer/mortgage-rates'),
        type: 'link'
    },
    { 
        label: "Case Studies",
        to: buildUrlUsingBase('buyer/case-studies'),
        type: 'link'
    },
    { 
        label: "Current Offers",
        to: buildUrlUsingBase('buyer/current-offers'),
        type: 'link'
    },
    {
        label: "Financial Zown",
        to: 'https://www.linkedin.com/newsletters/the-financial-zown-7083899114496675841',
        type: 'link'
    },
    {
        label: "Contact Us",
        to: buildUrlUsingBase('contact-us'),
        type: 'link'
    }
]

export const sellResourcesPageLinks: MenuLinkItemType[] = [
    {
        label: "Checklist to Sell",
        to: buildUrlUsingBase('seller/home-selling-checklist'),
        type: 'link'
    },
    {
        label: "Financial Zown",
        to: 'https://www.linkedin.com/newsletters/the-financial-zown-7083899114496675841',
        type: 'link'
    },
    {
        label: "Contact Us",
        to: buildUrlUsingBase('contact-us'),
        type: 'link'
    }
]

export const sellBuyResourcesPageLinks: MenuLinkItemType[] = [
    {
        label: "Checklist to Sell",
        to: buildUrlUsingBase('seller/home-selling-checklist'),
        type: 'link'
    },
    {
        label: "Mortgage Rates",
        to: buildUrlUsingBase('buyer/mortgage-rates'),
        type: 'link'
    },
    {
        label: "Case Studies",
        to: buildUrlUsingBase('buyer/case-studies'),
        type: 'link'
    },
    {
        label: "Financial Zown",
        to: 'https://www.linkedin.com/newsletters/the-financial-zown-7083899114496675841',
        type: 'link'
    },
    {
        label: "Contact Us",
        to: buildUrlUsingBase('contact-us'),
        type: 'link'
    }
]